import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationMessage } from "../shared/models/models";
import { Register } from "../customer/shared/models/customerModels";
import customersApi from "../customer/shared/api/customersApi";
import { SerializedError } from "../shared/models/errorHandlingModels";
import { serializeError, createErrorNotification } from "../shared/utils/errorUtils";

interface StartRegistrationState {
  isLoading: boolean;
  isConfirmEmail: boolean;
  formNotificationMessage: NotificationMessage | null;
  email: string | null;
}

const initialState: StartRegistrationState = {
  isLoading: false,
  isConfirmEmail: false,
  formNotificationMessage: null,
  email: null,
};

export const startRegistration = createAsyncThunk(
  "startRegistration/startRegistration",
  async (model: Register, { rejectWithValue }) => {
    try {
      await customersApi.register(model);
      return { success: true, email: model.userName };
    } catch (error: any) {
      return rejectWithValue(serializeError(error));
    }
  }
);

const startRegistrationSlice = createSlice({
  name: "startRegistration",
  initialState,
  reducers: {
    clearNotification: (state) => {
      state.formNotificationMessage = null;
    },
    resetState: (state) => {
      state.isLoading = false;
      state.isConfirmEmail = false;
      state.formNotificationMessage = null;
      state.email = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startRegistration.pending, (state) => {
        state.isLoading = true;
        state.formNotificationMessage = null;
      })
      .addCase(startRegistration.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isConfirmEmail = true;
        state.email = action.payload.email;
      })
      .addCase(startRegistration.rejected, (state, action) => {
        state.isLoading = false;
        state.formNotificationMessage = createErrorNotification(action.payload as SerializedError);
      });
  },
});

export const { clearNotification, resetState } = startRegistrationSlice.actions;
export default startRegistrationSlice.reducer; 